<div fxLayout="column" fxFlexFill class="content-container" fxLayoutGap="5px">
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters"
                   [showFilterButton]="false"
                   [showDateRange]="false"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
    <app-filter-row-additional-content>
      <button mat-raised-button color="primary" matTooltip="Create a Event Flow" *ngIf="hasEditAccess"
              (click)="onCreateNewEventsFlow()">
        + Add
      </button>
    </app-filter-row-additional-content>
  </app-grid-filter>
  <div fxFlex class="stretched-container">
    <app-events-flow-grid [filterChangeEvent]="filterChangeEvent"></app-events-flow-grid>
  </div>
</div>
